"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var json_to_graphql_query_1 = require("json-to-graphql-query");
var Logger_1 = require("../util/Logger");
var Params_1 = require("../util/Params");
var TypeUtils_1 = require("../util/TypeUtils");
exports.QUERY = "__query__";
var ALIAS_FOR = "__aliasFor";
var ARGS = "__args";
var DIRECTIVES = "__directives";
var VARIABLES = "__variables";
var QueryType;
(function (QueryType) {
    QueryType["ONE"] = "one";
    QueryType["MANY"] = "many";
    QueryType["INLINE"] = "inline";
})(QueryType = exports.QueryType || (exports.QueryType = {}));
var MutationType;
(function (MutationType) {
    MutationType["CREATE"] = "create";
    MutationType["UPDATE"] = "update";
    MutationType["DELETE"] = "delete";
})(MutationType = exports.MutationType || (exports.MutationType = {}));
exports.setupQuery = function (cls) {
    if (TypeUtils_1.nDef(cls[exports.QUERY])) {
        cls[exports.QUERY] = { fields: [] };
        return true;
    }
    return false;
};
exports.isValidInstance = function (instance) { return (typeof instance === 'object' && typeof instance[exports.QUERY] === 'object'); };
var parseField = function (field, paramData, paramCallback, depth) {
    if (depth === void 0) { depth = 0; }
    var _a;
    var f = {};
    if (typeof field.includeIf === 'function' && !field.includeIf(paramData)) {
        return false;
    }
    if (typeof field.directive === 'string') {
        f[DIRECTIVES] = (_a = {}, _a[field.directive] = true, _a);
    }
    if (Params_1.isValidParams(field.params)) {
        var fieldParams = Params_1.getParams(field.params, paramData);
        if (Object.keys(fieldParams).length > 0) {
            f[ARGS] = fieldParams;
            paramCallback(fieldParams);
        }
    }
    if (TypeUtils_1.iDef(field.aliasFor)) {
        f[ALIAS_FOR] = field.aliasFor;
    }
    if (typeof field.entity !== 'undefined') {
        var instance = new field.entity();
        if (exports.isValidInstance(instance)) {
            var args = instance[exports.QUERY];
            depth++;
            args.fields.forEach(function (subfield) {
                f[subfield.name] = parseField(subfield, paramData, paramCallback, depth);
            });
        }
    }
    return Object.keys(f).length > 0 ? f : true;
};
var setupSchema = function (entityName, entity, paramData, alias) {
    var instance = new entity();
    if (exports.isValidInstance(instance)) {
        var args = instance[exports.QUERY];
        var schema = {};
        var variables_1 = {};
        var name_1 = TypeUtils_1.iDef(alias) ? alias : entityName;
        var aliasFor = TypeUtils_1.iDef(alias) ? entityName : undefined;
        var params = args.params === false ? {} : (Params_1.isValidParams(args.params) ? args.params : paramData || {});
        schema[name_1] = parseField({ aliasFor: aliasFor, entity: entity, name: name_1, params: params }, paramData || {}, function (fieldParams) { return Params_1.findVariables(fieldParams, function (variable) {
            var variableType = variable.getTypeString();
            if (TypeUtils_1.iDef(variables_1[variable.value]) && variables_1[variable.value] !== variableType) {
                Logger_1.default.throw("duplicate.variable");
            }
            variables_1[variable.value] = variableType;
        }); });
        if (Object.keys(variables_1).length > 0) {
            schema[VARIABLES] = variables_1;
        }
        return schema;
    }
};
exports.generateQuery = function (clazz, type, paramData, alias) {
    var instance = new clazz();
    if (Object.values(QueryType).indexOf(type) < 0) {
        Logger_1.default.throw("invalid.query");
    }
    if (exports.isValidInstance(instance)) {
        return json_to_graphql_query_1.jsonToGraphQLQuery({
            query: setupSchema(instance[exports.QUERY][type], clazz, paramData, alias)
        });
    }
    Logger_1.default.throw("invalid.class");
};
exports.generateMutation = function (clazz, type, paramData, alias) {
    var instance = new clazz();
    if (Object.values(MutationType).indexOf(type) < 0) {
        Logger_1.default.throw("invalid.mutation");
    }
    if (exports.isValidInstance(instance)) {
        return json_to_graphql_query_1.jsonToGraphQLQuery({
            mutation: setupSchema(instance[exports.QUERY][type], clazz, paramData, alias)
        });
    }
    Logger_1.default.throw("invalid.class");
};
//# sourceMappingURL=query.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/typegraph/dist/query/query.js
// module id = 324
// module chunks = 0